import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../Shared/API/config';

export const noticeboardApi = createApi({
  reducerPath: 'noticeboardApi',
  baseQuery,
  tagTypes: ['Notice'],
  endpoints: builder => ({
    getNotices: builder.query<any, { search: string }>({
      query: ({ search }) => {
        const queryString = search ? `?q=${encodeURIComponent(search)}` : '';
        return `/noticeboard/notices${queryString}`;
      },
      providesTags: ['Notice'],
    }),
    dismissNotice: builder.mutation<any, any>({
      query: noticeId => ({
        url: `/noticeboard/notices/${noticeId}/dismiss`,
        method: 'POST',
      }),
      invalidatesTags: ['Notice'],
    }),
    dismissAllNotices: builder.mutation<void, void>({
      query: () => ({
        url: '/noticeboard/notices/dismiss-all',
        method: 'POST',
      }),
      invalidatesTags: ['Notice'],
    }),
  }),
});

export const {
  useGetNoticesQuery,
  useDismissNoticeMutation,
  useDismissAllNoticesMutation,
} = noticeboardApi;
